import MultipleChoice from "./MultipleChoice.vue";
import Ranking from "./Ranking.vue";
import Slider from "./Slider.vue";
import Text from "./Text.vue";
import Weighting from "./Weighting.vue";
import Word from "./Word.vue";
import Voice from "./Voice.vue";

export default {
    multiple_choice: MultipleChoice,
    ranking: Ranking,
    slider: Slider,
    text: Text,
    weighting: Weighting,
    word: Word,
    voice: Voice,
    gatekeeper: MultipleChoice,
};
